import React, { useContext } from 'react'
import Footer from '../Footer/Footer'
import GalleryStrip from './GalleryStrip/GalleryStrip'
import "./WelcomePage.scss";
import { AppContext } from '../../Stores/App.store';
import TopBar from '../TopBar/TopBar';
import { navigationPush, vPush } from '../../Services/Analytics';


const WelcomePage = () => {

    const { setPageView, pageView } = useContext(AppContext)!;

    const buttonPress = () => {
        setPageView("content");
        vPush("/trips-memories/articles", "נזכרים בטיולים - עמוד כתבות")
        vPush("/trips-memories/article/1", "נזכרים בטיולים - להגשים חלום בסיביר: כשצילמתי את אגם באיקאל הקפוא")
        navigationPush("Start");
    }
    return (
        <div id="welcome-page" className={`${pageView === "welcome" ? "" : "content"}`}>
            <TopBar/>
            <div id="bg"></div>
            <div className="content-container">
                <h1>נזכרים בטיולים</h1>
                <h2>כשהקורונה התפשטה והשמיים נסגרו, ניסינו להתעודד באמצעות סיפורי מסעות מימים יפים יותר. 
                    ביקשנו מכם לספר לנו על טיולים נדירים שעשיתם ולשתף בחוויות בלתי נשכחות. במהרה גילינו כמה כיף להיזכר
                </h2>
                <button onClick={buttonPress}>הצטרפו למסע</button>
            </div>
            <GalleryStrip />
            <Footer />

        </div>
    )
}

export default WelcomePage
